<template>
    <c-dialog ref="dialog" title="编辑出行信息" mode="slide" width="1000"  @resolve="handleSubmit">
        <c-form ref="form" vertical unit-width="100%" column="2">
            <c-title>基础信息</c-title>
            <!-- 必要信息展示 -->
            <c-form-item label="售后申请单">
                <c-input v-model="displayInfo.apply_order_code" disabled></c-input>
            </c-form-item>
            <c-form-item label="客户名称">
                <c-input v-model="displayInfo.customer_name" disabled></c-input>
            </c-form-item>
            <c-form-item label="售后服务地址">
                <c-input v-model="displayInfo.customer_address_detail" disabled></c-input>
            </c-form-item>
            <c-form-item label="售后网点">
                <c-input v-model="displayInfo.after_sale_outlet_name" disabled></c-input>
                <template #tip>
                    <p v-if="displayInfo.customer_distance" style="color: #999;">距客户{{displayInfo.customer_distance}}公里，{{distanceTipWord}}</p>
                </template>
            </c-form-item>
            <c-form-item label="预约日期">
                <c-input v-model="displayInfo.appointment_start_time" disabled></c-input>
            </c-form-item>
            <c-form-item label="预计服务时长">
                <c-input v-model="displayInfo.estimated_service_days" disabled append-text="天"></c-input>
            </c-form-item>
            <c-form-item label="预计住宿天数">
                <c-input v-model="formData.accommodation_days" disabled name="accommodation_days" type="stepper" :range="[0,Infinity]" append-text="晚"></c-input>
            </c-form-item>
            <c-form-item label="预计上门人数">
                <c-input v-model="formData.estimated_technician_count" disabled name="estimated_technician_count" type="stepper" :range="[1,Infinity]" append-text="人"></c-input>
            </c-form-item>

            <c-title>出行信息</c-title>

            <!-- 可编辑字段 -->
            <c-form-item label="是否使用机台" required>
                <c-select v-model="formData.use_machine" name="use_machine" :options="useMachineOptions"></c-select>
            </c-form-item>
            <c-form-item label="出行方式" required>
                <c-select v-model="formData.travel_mode" name="travel_mode" :options="travelModeOptions" @change="handleTravelModeChange"></c-select>
            </c-form-item>
            <c-form-item v-show="formData.travel_mode == 2" label="公共交通费用" required>
                <c-input v-model="formData.public_travel_cost" name="public_travel_cost" type="number" decimal="2" :range="[0,Infinity]" append-text="元"></c-input>
            </c-form-item>
        </c-form>

        <!-- 预估成本展示 -->
        <dl class="expenses">
            <dt class="flex-between-center">
                <p>预估成本：</p>
                <strong>￥{{expensesDetail.estimated_cost_total || '-'}}</strong>
            </dt>
            <dd v-if="expensesDetail.estimated_cost_list.length">
                <ul>
                    <li v-for="(item, i) in expensesDetail.estimated_cost_list" :key="i" class="flex-between-center">
                        <span>{{item.fee_type_name}}：</span>
                        <span>￥{{item.amount}}</span>
                    </li>
                </ul>
            </dd>
        </dl>

        <template #button>
            <c-button size="form" @click="$refs.dialog.close()">取消</c-button>
            <c-button size="form" color="main" @click="handleSubmit">保存</c-button>
        </template>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: 'aftersaleOrderTravelEdit',

    data() {
        return {
            orderId: null,
            displayInfo: {
                apply_order_code: '',
                customer_name: '',
                customer_address_detail: '',
                after_sale_outlet_name: '',
                estimated_service_days: '',
                customer_duration: '',
                appointment_start_time: '',
                customer_distance: ''
            },
            formData: {
                use_machine: '',
                travel_mode: '',
                public_travel_cost: '',
                accommodation_days: '',
                estimated_technician_count: ''
            },
            expensesDetail: {
                estimated_cost_total: '',
                estimated_cost_list: []
            }
        }
    },

    computed: {
        ...mapState(['useMachineOptions', 'travelModeOptions']),
        distanceTipWord() {
            return '驾车预计耗时' + this.displayInfo.customer_duration + '小时';
        }
    },

    watch: {
        formData: {
            handler(data) {
                this.calculateExpenses();
            },
            deep: true
        }
    },

    methods: {
        open(orderId) {
            this.orderId = orderId;
            this.loadOrderDetail();
            this.$refs.dialog.open();
        },

        loadOrderDetail() {
            this.request({
                url: '/after/sale/order/detail',
                data: { id: this.orderId },
                success: ({detailInfo}) => {
                    this.displayInfo = {
                        apply_order_code: detailInfo.apply_order_code,
                        customer_name: detailInfo.customer_name,
                        customer_address_detail: detailInfo.customer_address_detail,
                        after_sale_outlet_name: detailInfo.after_sale_outlet_name,
                        estimated_service_days: detailInfo.estimated_service_days,
                        customer_duration: detailInfo.customer_duration,
                        customer_distance: detailInfo.customer_distance,
                        appointment_start_time: detailInfo.appointment_start_time
                    };
                    this.formData = {
                        use_machine: detailInfo.use_machine,
                        travel_mode: detailInfo.travel_mode,
                        customer_distance: detailInfo.customer_distance,
                        public_travel_cost: detailInfo.public_travel_cost,
                        accommodation_days: detailInfo.accommodation_days,
                        estimated_technician_count: detailInfo.estimated_technician_count,
                        estimated_service_days: detailInfo.estimated_service_days
                    };
                }
            });
        },

        handleTravelModeChange(value) {
            this.formData.public_travel_cost = value == 2 ? '' : '0';
        },

        calculateExpenses() {
            this.expensesDetail = {
                estimated_cost_total: '',
                estimated_cost_list: []
            };

            this._expensesRequest && this._expensesRequest.abort();

            if (!Object.keys(this.formData).find(key => this.formData[key] === '' || this.formData[key] === null)) {
                this._expensesRequest = this.request({
                    url: '/after/sale/order/cal/fee',
                    data: this.formData,
                    success: data => {
                        this.expensesDetail = data;
                    }
                });
            }
        },

        handleSubmit() {
            this.$refs.form.submit({
                url: '/after/sale/order/edit/travel_info',
                rule: {
                    use_machine: '请选择是否使用机台',
                    travel_mode: '请选择出行方式',
                    public_travel_cost: [{
                        type: 'empty',
                        message: '请填写公共交通费用',
                        skip: () => {
                            return this.formData.travel_mode != 2;
                        }
                    }]
                },
                dataFormatter: data => {
                    return {
                        id: this.orderId,
                        use_machine: this.formData.use_machine,
                        travel_mode: this.formData.travel_mode,
                        public_travel_cost: this.formData.public_travel_cost,
                        estimated_cost_total: this.expensesDetail.estimated_cost_total,
                        estimated_cost_json: JSON.stringify(this.expensesDetail)
                    };
                },
                success: () => {
                    this.$message({
                        message: '保存成功',
                        type: 'success'
                    });
                    this.$refs.dialog.close();
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.expenses {
    width: 100%;
    border-radius: 8px;
    padding: 0 20px;
    margin-top: 10px;
    background: #F9F9F9;
    box-sizing: border-box;

    dt {
        height: 50px;

        p {
            font-size: 16px;
            font-weight: bold;
        }

        strong {
            font-size: 18px;
            color: #FF0000;
        }
    }

    dd {
        padding-bottom: 15px;

        ul {
            padding-left: 0;
        }

        li {
            height: 24px;
            font-size: 13px;
            color: #999;
        }
    }
}
</style>
